import React from 'react'

export const contentFunctions = {
  displayContent(content, project, callback , that){
    if (content===project.tags && project.tags!=="" && content!==undefined){
      return(
        <div>
        <a onClick={() => this.handleTagClick2(project.primaryTag, callback)} style={{'listStyle':'none', 'color':'white'}}>
          {project.primaryTag}
        </a>
        {
          content.map((cont, key) => 
          <div key={key}>
            <a onClick={() => this.handleTagClick2(cont, callback)} style={{'listStyle':'none', 'color':'white'}} >
              {cont}
            </a>
          </div>
          )
        }
        </div>
        )
    }
    else if (content===project.hours && content!==undefined && !project.splitHours){
      return(
        content.map((cont, key) => 
          <li key={key} style={{'listStyle':'none'}} that={this}>
          
          {this.dayOfWeek(key) +": "} 

          { cont === " AM -  PM" &&
                " closed"
          }
          
          { cont !== " AM -  PM" &&
            cont} 
          </li>
          )
        )
    }
    else if (content===project.hours && content!==undefined && project.splitHours){
      return(
        content.map((cont, key) => 
          <li key={key} style={{'listStyle':'none'}} that={this}>

          {!(parseInt(key) % 2) && this.dayOfWeekSplit(key) +": "} 

          {!(parseInt(key) % 2) && cont === " AM -  PM" &&
                " closed"
          }
          
          { cont !== " AM -  PM" &&
            cont} 
          </li>
          )
        )
    }
    else if (content===project.address && content!==undefined){
      return(
        <div>
        <span>{content}</span>
        <br/>
        <span>{project.city + ", " + project.state + " " + project.zip}</span>
        </div>
        )
    }
    else if (content===project.blurb){
      console.log(content.split(','));
      return(
        <div style={{display:"flex"}}>
        <span>{content.split(',')[0]}</span>
        <br/>
        <span>{content.split(',')[1]}</span>
        <br/>
        <span>{content.split(',')[2]}</span>
        <span>{content.split(',')[3]}</span>
        <span>{content.split(',')[4]}</span>
        <span>{content.split(',')[5]}</span>
        </div>
      )
    }
    else if (content==="Click or tap on a review to expand."){
      return(content)
    }
    else if (content==="reddit"){
      return(null)
    }
    else{
      let isOpen = content.split(',')[1];
      var rev = " reviews ";
      var star = " stars ";
      if(content.split(',')[3] == 1){
        rev = " review "
      }
      else{
        rev = " reviews "
      }
      if(content.split(',')[4] == 1){
        star = " star "
      }
      else{
        star = " stars "
      }

      return(
        <div style={{display:"flex", flexFlow:"column"}}>
          <div onClick={()=>{that.setState({newLastClicked:'hours'})}}>{isOpen !== undefined && isOpen.toUpperCase() + content.split(',')[6]}</div>
          <div style={{display:"flex", flexFlow:"row", justifyContent:"space-between", paddingLeft:"10px", paddingRight:"10px"}}>
          <div onClick={()=>{that.setState({newLastClicked:'address'})}}>{content.split(',')[2] + " mi"}</div>
          <div onClick={()=>{that.setState({newLastClicked:'reviews'})}}>{content.split(',')[4] !== "unknown"?
            content.split(',')[3] + rev + content.split(',')[4] + star :
           content.split(',')[3] + rev}</div>
           </div>
          <div onClick={()=>{that.setState({newLastClicked:'reddit'})}}>{content.split(',')[7] + ' reddit comments'}</div>
        </div>
      )
    }
  },
  handleTagClick2(tag, callback){
    // console.log('tag click');
    // console.log(tag)
    callback(tag);
  },
  dayOfWeek(number){
    switch(number){
      case 0:
        return('Sunday')
      case 1:
        return('Monday')
      case 2:
        return('Tuesday')
      case 3:
        return('Wednesday')
      case 4:
        return('Thursday')
      case 5:
        return('Friday')
      case 6:
        return('Saturday')
      default:
        return('Oops')
    }
  },
  dayOfWeekSplit(number){
    switch(number){
      case 0:
        return('Sunday')
      case 2:
        return('Monday')
      case 4:
        return('Tuesday')
      case 6:
        return('Wednesday')
      case 8:
        return('Thursday')
      case 10:
        return('Friday')
      case 12:
        return('Saturday')
      default:
        return('Oops')
    }
  }

}